export enum ReturnCodeType {
  Unknown = -1,
  NoError = 0,
  TokenExpired = 1,
  BadAuthorization = 2,
  InvalidInput = 3,
  OverBetCredit = 4,
  OverPlayerMaxWin = 5,
  OverPlayerMaxLose = 6,
  PlayerIsNotLogin = 7,
  ApiSuspended = 8,
  InternalError = 9,
  OverMaxBet = 10,
  LowerThanMinBet = 11,
  BetTooFrequent = 12,
  ApiError = 13,
  InputIncorrect = 14,
  InvalidGameStatus = 15,
  CannotFindOldLiveGameId = 16,
  BetNotFound = 17,
  BetSettled = 18,
  BetCanceled = 19,
  BetExisted = 20,
  InsufficientBalance = 21,
  BadRequest = 22,
  Unauthorized = 23,
  Forbidden = 24,
  OperatorInternalServerError = 25,
  ExitedOrdersCannotChangeTableLimit = 26,
  VoucherIsNotValid = 27,
  VoucherNotApplied = 28,
  CanNotFindTableLimit = 29,
  GetPlayerFail = 30,
  PlaceBetFail = 31,
  InternalServerError = 500,
  NoNetWorkError = 9999,
  DBError = 29999,
  BetWasCanceled = 30000,
  InvalidPlayerConnectionStatus = 30001,
  VoucherError = 35,
}
